import { mapGetters } from 'vuex';

/**
 * Store getters map
 * @mixin
 * @displayName Globally Mapped Getters
 */
export default {
  computed: {
    ...mapGetters({
      $selectedDockIds: 'Calendar/selectedDockIds',
      $warehouseEventsByDock: 'Calendar/warehouseEventsByDock',
      $docksKeyedById: 'Calendar/docksKeyedById',
      $loadTypeName: 'LoadTypes/loadTypeName',
      $getSettingValue: 'Settings/settingValue',
      $refNumSettings: 'Settings/refNumSettings',
      $isMilitaryTimeEnabled: 'Settings/isMilitaryTimeEnabled',
      $appointmentJoins: 'Appointments/appointmentJoins',
      // PERMISSIONS
      $isWarehouseReadOnly: 'Auth/isWarehouseReadOnly',
      $isLoadTypeReadOnly: 'Auth/isLoadTypeReadOnly',
      $isDockReadOnly: 'Auth/isDockReadOnly',
      $isOrgReadOnly: 'Auth/isOrgReadOnly'
    })
  }
};
